import { CreditCard } from "lucide-react";

import { AUTOMATICAS, reais, totalVendido } from "../lib/caixa";

/** Quanto entrou em cada forma neste caixa, em barras. */
export default function VendasPorForma({ resumo }) {
  const vendas = [...(resumo?.vendas_por_pagamento || [])].sort((a, b) => (b.total || 0) - (a.total || 0));
  const total = totalVendido(resumo) || 1;
  const estornos = (resumo?.estornos || []).reduce((s, e) => s + (e.total || 0), 0);
  return (
    <section className="rounded-2xl border bg-card p-4 sm:p-5" data-e2e="vendas-por-forma">
      <h3 className="font-bold flex items-center gap-2 mb-3"><CreditCard className="w-4 h-4 text-primary" />Vendas por forma de pagamento</h3>
      {!vendas.length ? <p className="text-sm text-muted-foreground">Nenhuma venda neste caixa.</p> : (
        <ul className="space-y-3">
          {vendas.map((v) => (
            <li key={v.forma_pagamento}>
              <div className="flex items-baseline gap-2 text-sm">
                <span className="font-medium">{v.forma_pagamento || "Outros"}</span>
                {AUTOMATICAS.includes(v.forma_pagamento) && <span className="text-[10px] px-1.5 py-0.5 rounded bg-muted text-muted-foreground uppercase">online</span>}
                <span className="text-xs text-muted-foreground">{v.qtd}×</span>
                <span className="ml-auto font-semibold tabular-nums">{reais(v.total)}</span>
              </div>
              <div className="h-2 rounded-full bg-muted mt-1 overflow-hidden"><div className="h-full rounded-full bg-primary" style={{ width: `${((v.total || 0) / total) * 100}%` }} /></div>
            </li>
          ))}
        </ul>
      )}
      {estornos > 0 && (
        <p className="mt-3 text-xs text-amber-700 dark:text-amber-400" data-e2e="estornos-caixa">
          Já descontados {reais(estornos)} de pedidos cancelados depois de concluídos (estornos).
        </p>
      )}
    </section>
  );
}
